<script>
	import { cookieConsent } from '$lib/cookieConsent.svelte.js';
	import { t } from '$lib/i18n.svelte.js';
	import { page } from '$app/state';
	
	// State
	let isHovered = $state(false);
	
	// Check if we're on the front page (root language routes like /fr or /en)
	const isOnFrontPage = $derived(() => {
		const pathname = page?.url?.pathname || '';
		// Match pattern: /[lang] or /[lang]/ (front page with language prefix)
		return /^\/[a-z]{2}\/?$/.test(pathname);
	});
	
	// Only show icon if consent has been set, banner is not currently needed, and we're on front page
	const showIcon = $derived(
		cookieConsent.state.hasBeenSet && !cookieConsent.needsBanner && isOnFrontPage()
	);
	
	/**
	 * Handle icon click - trigger the main banner to show
	 */
	function handleClick() {
		cookieConsent.showBanner();
	}
</script>

{#if showIcon}
	<button
		onclick={handleClick}
		onmouseenter={() => isHovered = true}
		onmouseleave={() => isHovered = false}
		class="fixed bottom-4 left-4 z-40 p-3 bg-white border border-gray-200 rounded-full shadow-md hover:shadow-lg transition-all duration-200 group"
		aria-label={t('cookies.preferencesTitle')}
		title={t('cookies.preferencesTitle')}
	>
		<svg 
			class="w-5 h-5 text-gray-600 group-hover:text-blue-600 transition-colors" 
			fill="none" 
			stroke="currentColor" 
			viewBox="0 0 24 24"
		>
			<path 
				stroke-linecap="round" 
				stroke-linejoin="round" 
				stroke-width="2" 
				d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
			/>
			<path 
				stroke-linecap="round" 
				stroke-linejoin="round" 
				stroke-width="2" 
				d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
			/>
		</svg>
		
		{#if isHovered}
			<span class="absolute bottom-full left-0 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded whitespace-nowrap">
				{t('cookies.preferencesTitle')}
			</span>
		{/if}
	</button>
{/if}